import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Clipboard, Check, ExternalLink, Share2 } from "lucide-react";
import { useToast } from "@/hooks/use-toast";
import { Link } from "react-router-dom";
import { Brand } from "@/types/photos";
import { generateUploadUrlLink } from "@/utils/routes";

interface BrandUploadLinkProps {
  brand: Brand;
}

const BrandUploadLink: React.FC<BrandUploadLinkProps> = ({ brand }) => {
  const { toast } = useToast();
  const [copied, setCopied] = useState(false);

  const uploadLink = generateUploadUrlLink(brand);

  console.log(`🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁🦁BRAND NAME: ${brand.name}🦁🦁🦁��🦁🦁🦁🦁🦁🦁🦁`);
  const handleCopyLink = () => {
    navigator.clipboard.writeText(uploadLink);
    setCopied(true);

    toast({
      title: "Link Copied!",
      description: "Upload link copied to clipboard. You can now share it with your customers.",
    });

    // Reset the copied state after 2 seconds
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Card className="border-2 border-primary/20 bg-card shadow-md">
      <CardHeader className="bg-muted/50 pb-4">
        <div className="flex items-center gap-2">
          <Share2 className="h-5 w-5 text-primary" />
          <CardTitle className="text-xl">Your Customer Upload Link</CardTitle>
        </div>
        <CardDescription className="mt-1">
          Share this link with your customers so they can upload photos directly to your brand
        </CardDescription>
      </CardHeader>
      <CardContent className="pt-6 space-y-4">
        <div className="relative">
          <Input
            readOnly
            value={uploadLink}
            className="pr-24 font-mono text-sm"
            onClick={(e) => (e.target as HTMLInputElement).select()}
          />
          <div className="absolute right-1 top-1 flex gap-1">
            <Button
              size="sm"
              variant="ghost"
              className="h-7 px-2 text-xs"
              asChild
            >
              <Link to={uploadLink} target="_blank" className="flex items-center gap-1">
                <ExternalLink className="h-3.5 w-3.5" />
                <span className="sr-only md:not-sr-only">Open</span>
              </Link>
            </Button>

            <Button
              size="sm"
              variant="secondary"
              className="h-7 px-3"
              onClick={handleCopyLink}
            >
              {copied ? (
                <>
                  <Check className="h-3.5 w-3.5 mr-1" />
                  <span className="text-xs">Copied</span>
                </>
              ) : (
                <>
                  <Clipboard className="h-3.5 w-3.5 mr-1" />
                  <span className="text-xs">Copy</span>
                </>
              )}
            </Button>
          </div>
        </div>

        <div className="text-sm text-muted-foreground">
          <p>You can include this link in emails, your website, or product packaging to collect customer photos.</p>
          <p className="mt-2 font-medium text-primary">When customers upload photos, they'll appear in your "Pending" tab for review.</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default BrandUploadLink;
